import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
const volumes = [['Volumen 1 — El Código de la Proteína Estratégica', ['Entendés por qué algunos días la pastilla funciona y otros no', 'Organizás desayuno, almuerzo y cena para que la medicación llegue al cerebro', 'Arrancás con un plan claro desde el Día 1'], 'border-blue-400/30'], ['Volumen 2 — Protocolo Desinflamatorio 21 Días', ['Entendés por qué el intestino es la clave que nadie te explicó', 'Mejorás la absorción de la medicación desde adentro', 'Notás cambios en la energía desde la primera semana'], 'border-green-400/30'], ['Volumen 3 — Sincronización de pH y Absorción Acelerada', ['Usás agua y temperatura para acelerar el efecto de la pastilla', 'Reducís los períodos de espera entre la toma y el efecto “ON”', 'Aplicás ajustes simples sin ningún producto especial'], 'border-amber-400/30'], ['Volumen 4 — El Mapa de los Datos: Monitor de Fluctuaciones y Control Total', ['Registrás síntomas y horarios de forma simple y ordenada', 'Llegás al neurólogo con información clara en vez de sensaciones vagas', 'Convertís la incertidumbre diaria en datos que te dan control'], 'border-red-400/30'], ['Volumen 5 — Activadores de Circulación y Movimiento Post-Toma', ['Aplicás movimientos simples que potencian el efecto de la medicación', 'Reducís la rigidez matutina con una rutina de 3 minutos', 'Vivís los momentos “ON” con más movilidad y confianza'], 'border-yellow-400/30']] as const;
const bonuses = [['01', 'Plan 7 Días de Implementación Parkinson Bajo Control', ['Sabés exactamente qué hacer cada día sin perderte', 'Evitás el agobio de empezar un sistema nuevo', 'Tenés una ruta clara desde el primer día'], '$12.000'], ['02', 'Kit de Consulta al Neurólogo: Preguntas y Resumen Listo', ['Llegás al turno con datos concretos y preguntas preparadas', 'Aprovechás al máximo cada consulta médica', 'Dejás de salir del consultorio con más dudas que certezas'], '$10.000'], ['03', 'Manual Casa Segura: Checklist Anticaídas para Parkinson', ['Detectás los riesgos ocultos del hogar en menos de una tarde', 'Convertís baño, dormitorio y pasillos en zonas más seguras', 'Reducís la sensación de alerta permanente dentro de casa'], '$9.000'], ['04', 'Guiones del Cuidador: Cómo Lograr Cooperación sin Peleas', ['Lográs que tu familiar coopere con la rutina sin discusiones', 'Usás frases simples que abren el diálogo en vez de cerrarlo', 'Bajás la tensión en los momentos más difíciles del día'], '$11.000'], ['05', 'Organizador Visual de Medicación y Rutina Diaria', ['Toda la rutina en una sola hoja que cualquier familiar puede seguir', 'Evitás olvidos, confusiones y errores de horario', 'Compartís la organización por WhatsApp en segundos'], '$10.000']] as const;
export function ProductOffer() {
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-128">
        <div className="mx-auto max-w-5xl" data-id="element-129">
          <header className="text-center" data-id="element-130">
            <h2 className="font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-131">
              PROTOCOLO — PARKINSON BAJO CONTROL™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-lg font-medium sm:text-xl" data-id="element-132">
              Tu hoja de ruta en 5 volúmenes para sincronizar la medicación,
              recuperar los momentos “ON” y tener una rutina predecible.
            </p>
            <h3 className="mt-12 font-display text-2xl font-bold" data-id="element-133">
              5 VOLÚMENES COMPLETOS
            </h3>
          </header>
          <div className="mt-7 space-y-5" data-id="element-134">
            {volumes.map(([title, items, border], index) => <motion.article key={title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className={`flex gap-5 rounded-2xl border ${border} bg-brand-ink p-5 sm:p-7`} data-id="element-135">
                <BookOpenIcon className="mt-1 h-7 w-7 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-136" />
                <div data-id="element-137">
                  <h4 className="font-display text-lg font-bold sm:text-xl" data-id="element-138">
                    {title}
                  </h4>
                  <ul className="mt-4 space-y-2" data-id="element-139">
                    {items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-140">
                        <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-141" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </motion.article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-brand-green/30 bg-brand-green/10 p-6 sm:p-8" data-id="element-142">
            <h4 className="text-center font-display text-xl font-bold" data-id="element-143">
              El Sistema incluye:
            </h4>
            <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-144">
              {['Plan diario listo para arrancar hoy', 'Cronograma de sincronización de 21 días', 'Guía de registro para el neurólogo', 'Checklist imprimible por etapa'].map(item => <p key={item} className="flex gap-2 text-slate-200" data-id="element-145">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-146" />
                  {item}
                </p>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-147">
        <div className="mx-auto max-w-5xl" data-id="element-148">
          <header className="text-center" data-id="element-149">
            <GiftIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-150" />
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-151">
              5 BONOS ESTRATÉGICOS
            </h2>
            <p className="mt-2 font-semibold tracking-[.18em]" data-id="element-152">
              SIEMPRE INCLUIDOS
            </p>
          </header>
          <div className="mt-10 space-y-4" data-id="element-153">
            {bonuses.map(([number, title, details, value]) => <article key={number} className="flex flex-col gap-4 rounded-2xl border border-brand-gold/20 bg-brand-dark p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-154">
                <span className="w-fit rounded-lg bg-brand-gold/10 px-3 py-2 font-bold text-brand-gold" data-id="element-155">
                  BONO {number}
                </span>
                <div className="flex-1" data-id="element-156">
                  <h3 className="font-bold" data-id="element-157">{title}</h3>
                  <ul className="mt-3 space-y-2" data-id="element-158">
                    {details.map(detail => <li key={detail} className="flex gap-2 text-sm leading-relaxed text-slate-300" data-id="element-159">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-160" />
                        {detail}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-161">
                  <span className="text-sm text-slate-500 line-through" data-id="element-162">
                    {value}
                  </span>
                  <span className="rounded-full bg-brand-light px-3 py-1 text-sm font-bold text-brand-ink" data-id="element-163">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-brand-gold/30 bg-brand-gold/10 p-6 text-center" data-id="element-164">
            <p className="text-xs font-bold tracking-[.17em] text-brand-gold" data-id="element-165">
              VALOR TOTAL BONOS
            </p>
            <p className="mt-1 text-2xl font-bold text-slate-400 line-through" data-id="element-166">
              $52.000
            </p>
            <p className="mt-2 font-display text-xl font-bold text-brand-gold" data-id="element-167">
              GRATIS con tu Protocolo — Parkinson Bajo Control™
            </p>
          </div>
        </div>
      </section>
    </>;
}